import React from 'react'
import Header from './Components/Header/Header'
const Contact = () => {
  return (
    <div>
      <Header />
    </div>
  )
}

export default Contact